import { useMemo } from 'react';
import { flow } from 'lodash';

import { sanitize } from '../../../utils/sanitize/sanitize';
import { createMarkdownRenderer } from './Markdown.helpers';

const markdown = createMarkdownRenderer();

const renderMarkdown = (text: string): string => {
    return markdown.render(text);
};

/**
 * Хук для преобразования markdown-текста в безопасный HTML
 * @param content - Исходный markdown-текст
 * @returns Безопасный HTML-контент
 */
export const useMarkdownContent = (content: string): string => {
    return useMemo(() => {
        return flow([renderMarkdown, sanitize])(content);
    }, [content]);
};
